import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { GET_SWIMMING_COURSE_OFFER_URL } from "../../api/apiRoutes";
import { LessonPass } from "../../models/LessonPass";

interface UseSwimmingCourseOfferResult {
  data: LessonPass | null;
  loading: boolean;
  error: string;
}

export default function useSwimmingCourseOffer(): UseSwimmingCourseOfferResult {
  const [searchParams] = useSearchParams();
  const { get } = useApiRequest();

  const [data, setData] = useState<LessonPass | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const objectIds = searchParams.get("id");
    const a = searchParams.get("a");

    if (!objectIds || !a) {
      setError("Nieprawidłowy link. Brakuje wymaganych parametrów.");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError("");

      const { result, isError, errorTable } = await get(GET_SWIMMING_COURSE_OFFER_URL(objectIds, a));

      if (isError) {
        setError(errorTable?.[0] ?? "Nie udało się pobrać danych oferty. Spróbuj ponownie.");
      } else {
        setData(result as LessonPass);
      }

      setLoading(false);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, loading, error };
}
